import Burger from './Burger';

document.addEventListener('DOMContentLoaded', () => {
  const burgerWrapper = document.querySelector('.js-burger');
  if (!burgerWrapper) return;

  const control = burgerWrapper.querySelector('.js-burger-control');
  const target = burgerWrapper.querySelector('.js-burger-target');
  if (!control || !target) return;

  const burger = new Burger(burgerWrapper, { control, target });

  function checkWindowWidth() {
    if (window.innerWidth <= 1208) {
      burger.mount();
    } else {
      burger.unmount();
      document.querySelector('header').classList.remove('is-open');
      document.querySelector('.c-header__content').removeAttribute('hidden');
    }
  }

  checkWindowWidth();

  window.addEventListener('resize', checkWindowWidth);
});
